export default "__VITE_ASSET__5808cf75__"